/**
 *
 * Modal
 * 
 * Modal cleanup and helper functions
 */
 const $         = require( 'jQuery' );

 var Modal = function(){
    //cache variables
    this.$el = $('.itbl-c-modal');

    this.init();
 };
 
 Modal.prototype.init = function(){
    var uniqueIDs = [];

    // remove all duplicate modals
    this.$el.each(function(){
        var $this = $(this);
        var id = $this.attr('id');
        if(uniqueIDs.indexOf(id) === -1){
            uniqueIDs.push(id);
        } else {
            // remove element
            $this.parent('.reveal-overlay').remove();
        }
    });
 };
 
 $(document).ready(function(){
    new Modal();
 });
 
 